import React, {Component} from 'react';

import AUX from '../../hoc/Aux_';
import Button from '@material-ui/core/Button';
import MUIDataTable from "mui-datatables";


import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import BorderColorTwoToneIcon from '@material-ui/icons/BorderColorTwoTone';
import Dialog from '@material-ui/core/Dialog';
import DialogDetail from '../../components/Kugi/dialogdetail';
import { connect } from 'react-redux';
import {pushDictionary} from '../../actions/general';
import {fetchDictionary } from '../../api/kugi';
import {deleteDictionary } from '../../api/dictionary';
import IconButton from '@material-ui/core/IconButton';
import { Alert, AlertTitle } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import AddDictionary from './AddDictionary';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Link } from 'react-router-dom';



class Dictionary extends Component{

  constructor(props) {
    super(props);
    this.state = {
      dictionary: [],
      open : false,
      dataUpdate: []
    }
  }

  componentWillMount(){
    fetchDictionary()
      .then(response => {
        this.props.pushDictionary(response.data);

        const arr = [];
        response.data.map((e)=>{
          arr.push(["update",e.word, e.wordTarget, e.dictionaryId]);
        })
        this.setState({dictionary:arr});

      })
      .catch(error => {
        console.log(error);
      });
  }

  handleClose = () =>{

    fetchDictionary()
      .then(response => {
        this.props.pushDictionary(response.data);
        const arr = [];
        response.data.map((e)=>{
          arr.push(["update",e.word, e.wordTarget, e.dictionaryId]);
        })
        this.setState({dictionary:arr});

      })
      .catch(error => {
        console.log(error);
      });
      this.setState({open:false});
  }

  handleDelete = (e) => {
    console.log(e.data[0].index);
    console.log(this.state.dictionary);
    let dictioanryId = this.state.dictionary[e.data[0].index][3].replace("@en", "");

    deleteDictionary(dictioanryId)
      .then(response => {
        console.log("deleted");
      })
      .catch(error => {
        console.log(error);
      });

  }

  handleUpdate = (e)=>{

    this.setState({dataUpdate: e.rowData, open: true });

  }

  handleReload = (e)=>{
    console.log(e);
    fetchDictionary()
      .then(response => {
        this.props.pushDictionary(response.data);
        const arr = [];
        response.data.map((e)=>{
          arr.push(["update",e.word, e.wordTarget, e.dictionaryId]);
        })
        this.setState({dictionary:arr});

      })
      .catch(error => {
        console.log(error);
      });
  }

  render(){
    const options = {
      filterType: 'checkbox',
      onRowsDelete: this.handleDelete
    };

    const columns = [
      {
        name:"Update",
        options: {
         filter: true,
         sort: false,
         customBodyRender: (value, tableMeta, updateValue) => (
           <BorderColorTwoToneIcon color="primary" onClick={event => this.handleUpdate(tableMeta)} style = {{cursor:"pointer"}}/>
         )
        }
      },
      {name:"Word"},
      {name:"WordTarget"},
      {name:"dictionaryId", options: {
       display: false
      }}
    ];


    return(
      <AUX>

        <Dialog
          open={this.state.open}
          fullScreen
          maxWidth={""}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle disableTypography style = {{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
          >
            <Alert severity="info">Add/Update Dictionary</Alert>
              <IconButton onClick={this.handleClose}>
                  <CloseIcon />
              </IconButton>
          </DialogTitle>
          <DialogContent>
              <AddDictionary handleOpen = {this.handleClose} data = {this.state.dataUpdate} handleReload = {this.handleReload} />
          </DialogContent>
        </Dialog>
        <section className="sections" style = {{paddingTop:"5%"}}>

          <div className="container">
            <Button variant="contained" color="primary" onClick = {()=>{this.setState({open:true, dataUpdate:[]})}}>Add Dictionary</Button>
            <MUIDataTable
            title={"Dictionary"}
            data={this.state.dictionary}
            columns={columns}
            options={options}
            />
            <div className="container">
                <div className="row justify-content-center" id="counter"/>
            </div>
          </div>
        </section>
      </AUX>
    )
  }


}

const mapStatetoProps = state => {

    return {
        dictionary: state.dictionary
    };
}


export default connect(mapStatetoProps, {pushDictionary})(Dictionary);
